import { gql } from "apollo-angular"

export var create_new_company_event = gql`
  mutation createCompanyEvent(
    $title: String
    $company_event_type_id: ID!
    $is_sponsored: Boolean
    $sponsorship_amount: Int
    $cosponsor: String
    $is_cosponsored: Boolean
  ) {
    createCompanyEvent(
      title: $title,
      company_event_type_id: $company_event_type_id,
      is_sponsored:$is_sponsored,
      sponsorship_amount: $sponsorship_amount,
      cosponsor: $cosponsor,
      is_cosponsored: $is_cosponsored
    ){
      id
    }
  }
`

export var create_new_company_event_datetime = gql`
  mutation createCompanyEventDate(
    $company_event_id: ID!
    $start_date: Date!
    $end_date: Date
    $start_time: String,
    $end_time: String,
    $timezone: String,
  ){
    createCompanyEventDate(
      company_event_id: $company_event_id,
      start_date: $start_date,
      end_date: $end_date,
      start_time: $start_time,
      end_time: $end_time,
      timezone: $timezone,
    ){
      id
      start_date
      end_date
      initial_date_time
      start_time
      timezone
      end_time
    }
  }
`

export var create_new_external_web_link = gql`
    mutation createWebAddress($protocol: Int, $subdomain: String, $domain: String!, $tld: String, $path: String, $parameters: String, $companyEventWebAddress: CreateCompanyEventWebAddressHasOne!){
      createWebAddress(protocol: $protocol, subdomain: $subdomain, domain: $domain, tld: $tld, path: $path, parameters: $parameters, companyEventWebAddress: $companyEventWebAddress){
        id
        protocol
        domain
        subdomain
        tld
        path
        parameters
        companyEventWebAddress {
          id
          name
        }
      }
    }
`

export var create_new_external_file = gql`
    mutation createCompanyEventFile($company_event_id: ID!, $drive_path_id: ID!, $path: String!){
      createCompanyEventFile(company_event_id: $company_event_id, drive_path_id: $drive_path_id, path: $path){
        id
        path
      }
    }
`

export var create_outlook_event = gql`
  mutation createOutlookEvent($event_id: ID!, $outlook_event_type_id: ID!, $outlook_calendar_id: ID!, $is_cancelled: Boolean! ){
    createOutlookEvent(event_id: $event_id, outlook_event_type_id: $outlook_event_type_id, outlook_calendar_id: $outlook_calendar_id, is_cancelled: $is_cancelled ){
      id
    }
  }
`

export var create_CREA_outlook_event = gql`
    mutation createCreaOutlookEvent($company_event_id: ID!, $outlook_event_id: ID!){
      createCreaOutlookEvent(company_event_id: $company_event_id, outlook_event_id: $outlook_event_id){
        id
        outlookEvent {
          event_id
          id
        }
      }
    }
`


